import React, {Fragment,useState,useRef,Suspense} from 'react';
import { useEffect } from 'react';
import {
    Table,Col, Row, Card,
    CardTitle, Button, Form, FormGroup, Label, Input, CardBody
} from 'reactstrap';
import VisualizzaModulo from './VisualizzaModulo.js';
import Parametri from '../../parametri';
import Clessidra from '../Clessidra.js';
import visualizzaIcon from "../../immagini/lente.png";
import downloadIcon from "../../immagini/download.png";

function ModulisticaPrecompilata(props) {

    const STATO_INDEFINITO = 0;
    const STATO_RICERCA = 1;
    const STATO_VISUALIZZA_ELENCO_MODULI = 2;
    const STATO_SCARICA_MODULO_DA_SERVER = 3;
    const STATO_VISUALIZZA_MODULO = 4;
    const STATO_DOWNLOAD_MODULO = 5;
    const STATO_ERRORE_CONNESSIONE = 6;

    const [statoPagina,setStatoPagina] = useState(STATO_INDEFINITO);
    const [sequenzaScaricaDatiIniziali, setSequenzaScaricaDatiIniziali] = useState(0); 
    const [elencoModuli,setElencoModuli] = useState([]);
    const [elencoRiferimenti, setElencoRiferimenti] = useState([]);
    const [indiceRiferimentoSelezionato, setIndiceRiferimentoSelezionato] = useState(-1);
    const [modulo, setModulo] = useState("");
    const [richiesta, setRichiesta] = useState("");
    const [titolo, setTitolo] = useState("");
    const [testo, setTesto] = useState("");
    const [testoReferente, setTestoReferente] = useState("");

    useEffect(() => {
        ricercaElencoModuli();        
    },[])

    useEffect(() => {
        if (statoPagina == STATO_SCARICA_MODULO_DA_SERVER) {
            scaricaModuloDaServer();
        }
    }, [statoPagina]);

    useEffect(() => {
        switch (sequenzaScaricaDatiIniziali) {
            case 0: ricercaElencoModuli(); break;
            case 1: ricercaRiferimentiIscritto(); break;
            case 2: setStatoPagina(STATO_VISUALIZZA_ELENCO_MODULI);
        }
    },[sequenzaScaricaDatiIniziali]);

    function ricercaElencoModuli() {
        setStatoPagina(STATO_RICERCA);
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"modulisticaPrecompilataElenco",emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {                
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                    setElencoModuli(valoreDiRitorno.risultatoRitorno);
                    setSequenzaScaricaDatiIniziali(sequenzaScaricaDatiIniziali+1);                                     
                } else {
                    props.setPagina(props.PAGINE.tornaLogin);
                }
            },
            (error) => {console.log(error); setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function ricercaRiferimentiIscritto() {
        //ricerco il saldo delle quote versate:
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoRiferimenti",soloReferenti:1,idIscritto:props.idIscritto,emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica (e.incassiabbass.3)");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                    setElencoRiferimenti(valoreDiRitorno.risultatoRitorno);
                    if (valoreDiRitorno.risultatoRitorno.length>0) setIndiceRiferimentoSelezionato(0); // seleziona il primo di default
                    setSequenzaScaricaDatiIniziali(sequenzaScaricaDatiIniziali+1);
                } else {
                    props.setPagina(props.PAGINE.tornaLogin);
                }                    
            },
            (error) => {setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function scaricaModuloDaServer() {
        setStatoPagina(STATO_RICERCA);
        var riferimentoCognomeNome = "";
        if (indiceRiferimentoSelezionato>=0) {
            riferimentoCognomeNome = elencoRiferimenti[indiceRiferimentoSelezionato].COGNOME+elencoRiferimenti[indiceRiferimentoSelezionato].NOME;
        }
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"modulisticaPrecompilataModulo",modulo:modulo,id:props.idIscritto,riferimentoCognomeNome:riferimentoCognomeNome,emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {                
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                    setTitolo(valoreDiRitorno.titolo);
                    setTesto(valoreDiRitorno.testo);
                    setTestoReferente(valoreDiRitorno.testoReferente);
                    if (richiesta == "visualizza") setStatoPagina(STATO_VISUALIZZA_MODULO);
                    else setStatoPagina(STATO_DOWNLOAD_MODULO);
                } else {
                    props.setPagina(props.PAGINE.tornaLogin);
                }
            },
            (error) => {console.log(error); setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    if (statoPagina == STATO_RICERCA) {
        return (<Clessidra loading={true}/>)
    }

    if (statoPagina == STATO_VISUALIZZA_ELENCO_MODULI || statoPagina == STATO_DOWNLOAD_MODULO) {
        return (
            <div>

                {elencoRiferimenti.length > 0 && 
                    <>
                        Dichiarante:
                        <select 
                            className="inputStandard" 
                            value={indiceRiferimentoSelezionato} 
                            onChange={(e) => {setIndiceRiferimentoSelezionato(e.target.value)}}
                        >
                            <option value={-1}>L'iscritto stesso</option>
                            {elencoRiferimenti.map((elemento, indice) => <option key={indice} value={indice}>{elemento.COGNOME+" "+elemento.NOME}</option>)}                                                    
                        </select>
                    </>
                }

                <div className='schedaSottotitolo'>
                    Modulistica Precompilata
                </div>

                {elencoModuli.length>0 &&
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      
                    <tbody>              
                        {elencoModuli.map((elemento,index) => 
                            <tr key={index}>
                            <td style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>{elemento.modulo}</td>
                            <td style={{ padding: "8px", borderBottom: "1px solid #ccc" }} align="center">
                                <div style={{display:"flex", flexDirection:"row"}}>
                                    <div
                                        onClick={() => {setModulo(elemento.modulo); setRichiesta("visualizza"); setStatoPagina(STATO_SCARICA_MODULO_DA_SERVER)}}
                                        style={{ flex:1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor:"#C6E9F9", marginRight:2, border: "1px solid black", borderRadius:5 }}
                                    >
                                        <img src={visualizzaIcon} width="30" height="30" alt="Visualizza"/>                      
                                    </div>
                                    <div
                                        onClick={() => {setModulo(elemento.modulo); setRichiesta("scarica"); setStatoPagina(STATO_SCARICA_MODULO_DA_SERVER)}}
                                        style={{ flex:1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor:"#C6E9F9", marginLeft:2, border: "1px solid black", borderRadius:5 }}
                                    >
                                        <img src={downloadIcon} width="30" height="30" alt="Download"/>
                                    </div>
                                </div>
                            </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                }                
                <br/>
                <i>Qui trovi i moduli precompilati per gli iscritti, per modificarne i contenuti o aggiungere altri moduli, contatta assistenza@gestionesportiva.it</i>

                {statoPagina == STATO_DOWNLOAD_MODULO && <VisualizzaModulo {...props} titolo={titolo} testo={testo} azione={"download"}/>}

            </div>            
        );
    }

    if (statoPagina== STATO_ERRORE_CONNESSIONE) {
        return (<div>Errore Modulistica Precompilata: errore connessione</div>);
    }

    if (statoPagina == STATO_VISUALIZZA_MODULO) {
        return (
            <div>
                <div className='schedaSottotitolo'>
                    {modulo}
                </div>
                <VisualizzaModulo {...props} titolo={titolo} testo={testo} azione={"visualizza"} callback={() => setStatoPagina(STATO_VISUALIZZA_ELENCO_MODULI)}/>
            </div>
        )
    }

    return (<div>Errore Modulistica Precompilata: pagina non trovata</div>);
}

export default ModulisticaPrecompilata;